import { ProjectPreview } from 'store/projects/interfaces';
import { EmployeeProjectPhases } from './interfaces';

export default function getProjectPhaseHelpers(
  employeeProjects: ProjectPreview[],
) {
  const employeeProjectsPhases = employeeProjects.reduce(
    (acc: EmployeeProjectPhases[], employeeProject) => {
      if (employeeProject.projectPhases.length) {
        acc.push({
          projectName: employeeProject.name,
          projectIri: employeeProject['@id'],
        });

        const sortedAlphabeticallyPhases = structuredClone(
          employeeProject.projectPhases,
        ).sort((currentEmployee, nextEmployee) =>
          currentEmployee.name.localeCompare(nextEmployee.name),
        );

        sortedAlphabeticallyPhases.forEach((employeeProjectPhase) => {
          acc.push({
            projectName: employeeProject.name,
            phaseName: employeeProjectPhase.name,
            projectIri: employeeProject['@id'],
            phaseIri: employeeProjectPhase['@id'],
          });
        });

        return acc;
      }

      acc.push({
        projectName: employeeProject.name,
        projectIri: employeeProject['@id'],
      });

      return acc;
    },
    [],
  );

  const getProjectPhaseText = (projectPhaseData: EmployeeProjectPhases) => {
    if (projectPhaseData.phaseName) {
      return `${projectPhaseData.projectName} - ${projectPhaseData.phaseName}`;
    }

    return projectPhaseData.projectName;
  };

  const getProjectPhaseKey = (projectPhaseData: EmployeeProjectPhases) => {
    if (projectPhaseData.phaseIri) {
      return `${projectPhaseData.projectIri} ${projectPhaseData.phaseIri}`;
    }

    return `${projectPhaseData.projectIri}`;
  };

  const getProjectPhaseValue = (projectPhaseData: EmployeeProjectPhases) => {
    const value = {
      projectIri: projectPhaseData.projectIri,
      ...(projectPhaseData.phaseIri && {
        phaseIri: projectPhaseData.phaseIri,
      }),
    };

    return JSON.stringify(value);
  };

  return {
    employeeProjectsPhases,
    getProjectPhaseText,
    getProjectPhaseKey,
    getProjectPhaseValue,
  };
}
